import { createContext, RefObject } from 'react';

/**
 * This context can be used to determine the element that the tooltip should be attached to.
 */
export const TooltipContext = createContext<RefObject<HTMLElement> | null>(null);
